import { useState } from "react";
import styles from "./index.module.scss";
import { Fb } from "@/components/svgs";
import {
  magnify,
  removeMagnifierGlass,
  DEFAULT_IMAGE_LINK,
} from "@/components/detailsComponent/helper";

const DesignToCart = ({ data }) => {
  const description =
    data?.description?.content?.[0]?.content?.[0]?.value || "";
  const mainImage = data?.image?.fields?.imageUrl || data?.imageUrl || "";
  const ctas = data?.ctas || [];
  const thumbnails = [
    {
      url: mainImage,
    },
  ];
  const socialIcons =
    data?.socialIcons?.fields?.images?.map(item => ({
      name: item?.fields?.name,
      url: item?.fields?.url,
    })) || [];
  const [activeImage, setActiveImage] = useState(data.image.url);
  const [isExpanded, setIsExpanded] = useState(false);
  const [zoomActive, setZoomActive] = useState(true);

  const handleMagnifier = (action, myImageId) => {
    removeMagnifierGlass();
    if (action === "enter") {
      magnify(myImageId, 2, undefined, true);
    }
  };
  return (
    <section className={styles.wrapper}>
      {/* NORMAL VIEW */}
      {!isExpanded && (
        <div className={styles.container}>
          {/* LEFT */}
          <div className={styles.left}>
            {/* Thumbnails */}
            <div className={styles.thumbnail}>
              {thumbnails.map((item, i) => (
                <img
                  key={i}
                  src={item.url}
                  alt="thumbnail"
                  onClick={() => setActiveImage(item.url)}
                  className={activeImage === item.url ? styles.active : ""}
                />
              ))}
            </div>
            {/* Main Image */}
            <div className={styles.imageWrapper}>
              <div
                className="img-magnifier-container h-full"
                onMouseEnter={e => {
                  setZoomActive(true);
                  handleMagnifier("enter", "mainImage");
                }}
                onMouseLeave={e => {
                  setZoomActive(false);
                  handleMagnifier("leave", "mainImage");
                }}
              >
                <img
                  src={mainImage}
                  alt="main"
                  id="mainImage"
                  width="620px"
                  height="465px"
                  className="w-full h-full"
                  onError={e => (e.target.src = DEFAULT_IMAGE_LINK)}
                />
              </div>

              <button
                className={styles.expandBtn}
                onClick={() => setIsExpanded(true)}
              />
              <i class="fa-light fa-arrows-maximize"></i>
            </div>
          </div>
          {/* RIGHT */}
          <div className={styles.right}>
            <h1>{data.title}</h1>
            <i class="fa-light fa-arrows-maximize"></i>
            <p className={styles.desc}>{description}</p>
            {ctas.length > 0 &&
              ctas?.map((cta, index) => {
                const { label, url, ctaType, openerType } = cta?.fields || {};
                if (ctaType === "Button") {
                  return (
                    <a
                      key={index}
                      href={url}
                      target={openerType === "New Tab" ? "_blank" : "_self"}
                      className={styles.primaryBtn}
                    >
                      {label}
                    </a>
                  );
                }
              })}
            <div className={styles.share}>
              <span className="text-[20px]">
                {data?.socialIcons?.fields?.heading || "Share:"}
              </span>
              {socialIcons.map((icon, index) => (
                <a
                  key={index}
                  class="share-facebook"
                  href="https://www.facebook.com/"
                  target="_blank"
                >
                  <div className="NavItems_iconWrapper__3LF5V w-[30px] text-[#999] mr-[10px] h-[30px] bg-[#fff] rounded-md flex items-center justify-center">
                    {icon.name?.toLowerCase() === "facebook" && <Fb />}
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
      {/* EXPANDED VIEW (MATCHES SCREENSHOT) */}
      {isExpanded && (
        <div className={styles.expandedView}>
          {/* Image Area */}
          <div className={styles.expandedImageWrap}>
            {/* Small Thumbnail */}
            <div className={styles.expandedThumb}>
              <img src={mainImage} alt="thumb" />
            </div>
            <img src={mainImage} alt="expanded" />
            <button
              className={styles.closeBtn}
              onClick={() => setIsExpanded(false)}
            />
          </div>
          {/* Details below (right aligned) */}
          <div className={styles.expandedDetails}>
            <div className={styles.detailsInner}>
              <h2>{data.title}</h2>
              <p>{description}</p>
              <div className="btn-shop">
                {ctas.length > 0 &&
                  ctas?.map((cta, index) => {
                    const { label, url, ctaType, openerType } =
                      cta?.fields || {};
                    if (ctaType === "Button") {
                      return (
                        <a
                          key={index}
                          href={url}
                          target={openerType === "New Tab" ? "_blank" : "_self"}
                          className={styles.primaryBtn}
                        >
                          {label}
                        </a>
                      );
                    }
                  })}
              </div>
              <div className={styles.share}>
                <span className="text-[20px]">
                  {data?.socialIcons?.fields?.heading || "Share:"}
                </span>
                {socialIcons.map((icon, index) => (
                  <a
                    key={index}
                    class="share-facebook"
                    href="https://www.facebook.com/"
                    target="_blank"
                  >
                    <div className="NavItems_iconWrapper__3LF5V w-[30px] text-[#999] mr-[10px] h-[30px] bg-[#fff] rounded-md flex items-center justify-center">
                      {icon.name?.toLowerCase() === "facebook" && <Fb />}
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
export default DesignToCart;
